var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5H19C19.275 24.5 19.5 24.275 19.5 24V22H21V24C21 25.1031 20.1031 26 19 26H12C10.8969 26 10 25.1031 10 24V17C10 15.8969 10.8969 15 12 15H14V16.5H12C11.725 16.5 11.5 16.725 11.5 17V24C11.5 24.275 11.725 24.5 12 24.5ZM17 19.5H24C24.275 19.5 24.5 19.275 24.5 19V12C24.5 11.725 24.275 11.5 24 11.5H17C16.725 11.5 16.5 11.725 16.5 12V19C16.5 19.275 16.725 19.5 17 19.5ZM15 19V12C15 10.8969 15.8969 10 17 10H24C25.1031 10 26 10.8969 26 12V19C26 20.1031 25.1031 21 24 21H17C15.8969 21 15 20.1031 15 19Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.efb5c8382934a60612e2791a32d3951a.svg";
export { ForwardRef as ReactComponent };